import React from 'react';
import logo from './logo.svg';
import './App.css';
import Form from './Form/form'

function App() {
  return (
    <div className="App">
      <Form/>
    </div>
  );
}

export default App;
